// extracted by mini-css-extract-plugin
export var behaviourform = "SectionBehaviourHelplineForm-module--behaviourform--8d45a";
export var fieldset = "SectionBehaviourHelplineForm-module--fieldset--3a16d";
export var input = "SectionBehaviourHelplineForm-module--input--c6219";
export var inputtextarea = "SectionBehaviourHelplineForm-module--inputtextarea--f0047";
export var inputwrapper = "SectionBehaviourHelplineForm-module--inputwrapper--8ab8e";
export var legend = "SectionBehaviourHelplineForm-module--legend--8be81";
export var select = "SectionBehaviourHelplineForm-module--select--e7331";
export var submitcontainer = "SectionBehaviourHelplineForm-module--submitcontainer--fcedc";
export var textinputlabel = "SectionBehaviourHelplineForm-module--textinputlabel--9f8c7";